module.exports = __webpack_public_path__ + "static/media/8.302b7c10.svg";